<template>
  <div class="home">

    <SeeMoreWrapper v-if="seeMoreBox" @close="seeMoreBox = false" @login="seeMoreLogin" @signUp="seeMoreSignUp"/>

    <Nav :separator="false">
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <TextBox text="Leap forward in speaking" color="white" fontSize="1.4rem"/>
      </template>
      <template v-slot:authentication-box>
        <LoginButton @click="onLogin" v-if="!TokenState"/>
        <SignupButton @click="onSignup" v-if="!TokenState"/>
        <DialoguesButton v-if="TokenState"/>
      </template>
    </Nav>

    <LoginBox v-if="login" @close="login = false" @resetPassword="onResetPassword" ref="loginBox"/>
    <SingupBox v-if="signup" @close="signup = false" :promoCode="promo_code" ref="signUpBox"/>
    <ResetPasswordBox v-if="resetPassword" :copiedEmail="resetEmail" @close="resetPassword = false"/>

    <div class="body">
      <Hero @onSignup="signup = true" @scrollDialogs="scrollToDialogsBox"/>
      <DialogsBox ref="dialogsBox" @openSeeMoreBox="seeMoreBox = true"/>
      <OpinionsBox/>
      <Footer/>
    </div>

  </div>
</template>

<script>
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import TextBox from '@/components/Nav/TextBox'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import LoginButton from '@/components/Nav/LoginButton'
import SignupButton from '@/components/Nav/SignupButton'

import LoginBox from '../components/Home/LoginBox'
import SingupBox from '../components/Home/SingupBox'
import ResetPasswordBox from '../components/Home/ResetPasswordBox'
import Hero from '../components/Home/Hero'
import DialogsBox from '../components/Home/DialogsBox'
import OpinionsBox from '../components/Home/OpinionsBox'
import Footer from '../components/Home/Footer'
import SeeMoreWrapper from '../components/Home/SeeMoreWrapper'

export default {
  name: 'Home',
  data() {
    return {
      login: false,
      signup: false,
      resetPassword: false,
      resetEmail: null,
      promo_code: null,
      seeMoreBox: false
    }
  },
  components: {
    Nav,
    Logo,
    TextBox,
    LoginButton,
    SignupButton,
    DialoguesButton,

    LoginBox,
    SingupBox,
    ResetPasswordBox,
    Hero,
    DialogsBox,
    OpinionsBox,
    Footer,
    SeeMoreWrapper
  },
  methods: {
    onLogin() {
      this.login = true;
    },
    onSignup() {
      this.signup = true;
    },
    onResetPassword(email) {
      this.resetEmail = email;
      this.login = false;
      this.resetPassword = true;
    },
    seeMoreLogin() {
      this.seeMoreBox = false;
      this.login = true;
      setTimeout(() => {
        let link = `${window.location.origin}/main?search=${this.$refs.dialogsBox.getCurrentTag}`;
        this.$refs.loginBox.nextLink = link;
      }, 1)
    },
    seeMoreSignUp() {
      this.seeMoreBox = false;
      this.signup = true;
      setTimeout(() => {
        let link = `${window.location.origin}/main?search=${this.$refs.dialogsBox.getCurrentTag}`;
        this.$refs.signUpBox.nextLink = link;
      }, 1)
    },
    scrollToDialogsBox() {
      this.$refs.dialogsBox.$el.scrollIntoView();
    }
  },
  computed: {
    TokenState() {
      if(localStorage.getItem('token') != null) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    const promo_code = urlParams.get('promo_code');

    if(action == 'login') {
      this.onLogin();
    }
    if(action == 'register') {
      this.promo_code = promo_code;
      this.onSingup();
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.body {
  width: 100%;
  flex: auto;
  display: flex;
  background-color: #F4F4F4;
  flex-direction: column;
  align-items: center;
}
</style>